export default "__VITE_ASSET__VWwheoQHW_e8UcRiND$XOg__ 480w, __VITE_ASSET__$6UtFC$ggZWao0xraMGF_A__ 768w, __VITE_ASSET__N8gdGaVyOLPWXNFayxWuYg__ 1122w";